import axios from 'axios';

import { BASE_URL } from './config';
const ENDPOINT = '/api/subjects/list/upload';

export function postStudentsSubjectList(file: File, plan: string) {
  const TOKEN = sessionStorage.getItem('Token');

  const apiClient = axios.create({
    baseURL: BASE_URL,
    headers: {
      'Content-Type': 'application/json',
      Authorization: 'Bearer ' + TOKEN,
    },
  });

  const formData = new FormData();
  formData.append('subjects', file);
  formData.append('plan', plan);

  return apiClient.post(ENDPOINT, formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
}
